// See your keys here: https://dashboard.stripe.com/account/apikeys
import { STRIPE_PUBLIC } from "./config"

export default Stripe(STRIPE_PUBLIC)
